












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TimestampAgo extends Vue {
  
  @Prop({ default: 0,  type: Number}) ts!: number;
  @Prop({ default: '',  type: String}) errorLabel!: string;
}
